import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  loading = false;
  incidentForm = {};
  feedbackReport = '';
  feedbackReportMsg = false;

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService
  ) {}

  ngOnInit() {
  }

  reportIncident() {
    // this.logService.printLog("incident form", this.incidentForm);
    this.incidentForm['user_id'] = this.dataService.userDetails['user_id'];
    this.loading = true;
    this.apiService.reportAnIncident(this.incidentForm, (response) => {
      this.loading = false;
      // this.logService.printLog("report incident -", response);
      if(response.response == 'error') {
        this.loading = false;
        this.feedbackReport = response.message;
      }else {
        this.loading = false;
        this.feedbackReport = response.message;
        this.feedbackReportMsg = true;
        this.incidentForm= {};
    }
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/report/report.component.ts